import type { WaitDescriptor } from '@volley/crucible-ipc-types/ipc-channels';

/**
 * Human-readable label for an outstanding wait.
 *
 * Uses the gate-authored `reason` when non-empty after trim; otherwise
 * falls back to a stable label derived from `kind`.
 */
export function formatWaitLabel(wait: WaitDescriptor): string {
  const reason = wait.reason.trim();
  if (reason.length > 0) return reason;
  switch (wait.kind) {
    case 'ask-user-question':
      return 'Plan review';
    case 'deps-request':
      return 'Dependency install';
  }
}
